module.exports = __webpack_public_path__ + "assets/img/020102.397e428b.png";